type PublicFooterProps = {
  onLogout: () => void;
};

export default function PublicFooter({ onLogout }: PublicFooterProps) {
  return (
    <footer className="public-page-footer">
      <button type="button" className="public-logout-button" onClick={onLogout}>
        Cerrar sesion
      </button>
    </footer>
  );
}
